// APPLICATION STORE
export const SHOW_SWEET_ALERT = "SHOW_SWEET_ALERT";
export const HIDE_SWEET_ALERT = "HIDE_SWEET_ALERT"; 
export const SHOW_NOTIFICATION = "SHOW_NOTIFICATION";
export const HIDE_NOTIFICATION = "HIDE_NOTIFICATION";

 